import { Component } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { ITab, TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { EntityListAction, FiscalYear, form_control, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { Datatransfer, VoucherKindInfo } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { GridFilter } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { AccVoucherFormComponent } from "src/app/backoffice/acc/accvoucher/accvoucher-form/accvoucher-form.component";
import { ReviewFilterItem } from "src/app/review/models/review-filter-item";
import { ReviewService } from "src/app/review/review.service";
import { SellVoucherFormComponent } from "../../sell-voucher/sell-voucher-form/sell-voucher-form.component";

@Component({
  selector: "sell-customer-review",
  templateUrl: "./sell-customer-review.component.html",
  styleUrls: ["./sell-customer-review.component.scss"],
  providers: [ReviewService],
})
export class SellCustomerReviewComponent extends BaseListComponent {
  actions: EntityListAction[];
  formGroup: UntypedFormGroup;
  GetSellVoucherKindColumns: form_control[] = [];
  GetSellKindColumns: form_control[] = [];
  GetWarehouseColumns: form_control[] = [];
  GetCustomerColumns: form_control[] = [];
  GetGoodsGroupColumns: form_control[] = [];
  GetGoodsColumns: form_control[] = [];
  GetSellerColumns: form_control[] = [];
  GetGoodsCardAmountColumns: form_control[] = [];
  GetGoodsCardPriceColumns: form_control[] = [];
  GetVoucherHeaderColumns: form_control[] = [];
  GetVoucherDetailColumns: form_control[] = [];
  SellVoucherKindIds: number[] = [];
  StatusKindIds: number[] = [];
  CustomerIds: number[] = [];
  BranchIds: number[] = [];
  GoodsIds: number[] = [];
  GoodsGroupIds: number[] = [];
  SellerIds: number[] = [];
  SellKindIds: number[] = [];
  WarehouseIds: number[] = [];
  activeTabTitle: string;
  selected: string = "";
  constructor(private service: ReviewService, private tabsservice: TabularService, private fb: UntypedFormBuilder) {
    super();
    this.onActionClick = this.onActionClick.bind(this);
  }

  ngOnInit(): void {
    this.service.startDate = new Date();
    this.service.endDate = new Date();
    let currentFiscalYear = this.accountService.authService.currentFiscalYear;

    this.setactions();
    if (currentFiscalYear) {
      this.service.startDate.setDate(this.service.startDate.getDate() - 30);
      this.service.startDate$.next(this.service.startDate);
      if (currentFiscalYear && currentFiscalYear.StartDate) {
        let fystartDate = new Date(currentFiscalYear.StartDate);
        if (fystartDate.setHours(0, 0, 0, 0) > this.service.startDate.setHours(0, 0, 0, 0))
          this.service.startDate = this.accountService.authService.currentFiscalYear.StartDate;
        else if (fystartDate.setHours(0, 0, 0, 0) < this.service.startDate.setHours(0, 0, 0, 0)) {
          this.service.startDate = currentFiscalYear.StartDate;
          this.service.endDate = currentFiscalYear.EndDate;
          this.service.startDate$.next(currentFiscalYear.StartDate);
          this.service.endDate$.next(currentFiscalYear.EndDate);
        }
      }
    } else
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x: FiscalYear) => {
        if (x && x.StartDate) {
          this.service.startDate.setDate(this.service.startDate.getDate() - 30);
          let fystartDate = new Date(x.StartDate);
          if (fystartDate.setHours(0, 0, 0, 0) > this.service.startDate.setHours(0, 0, 0, 0)) this.service.startDate = x.StartDate;
          else if (fystartDate.setHours(0, 0, 0, 0) < this.service.startDate.setHours(0, 0, 0, 0)) {
            this.service.startDate = x.StartDate;
            this.service.endDate = x.EndDate;
            this.service.startDate$.next(currentFiscalYear.StartDate);
            this.service.endDate$.next(currentFiscalYear.EndDate);
          }
        }
      });
    this.BranchIds.push(this.accountService.authService.currentBranchId);
    this.service.addFilter(this.accountService.authService.currentBranch.Title, [
      <ReviewFilterItem>{
        key: "BranchIds",
        value: this.accountService.authService.currentBranchId,
        title: this.accountService.authService.currentBranch.Title,
        persianKey: this.accountService.authService.currentBranch.Title,
      },
    ]);
    this.formGroup = this.fb.group({
      SellVoucherKindIds: this.SellVoucherKindIds,
      StatusKindIds: this.StatusKindIds,
      CustomerIds: this.CustomerIds,
      BranchIds: this.BranchIds,
      GoodsGroupIds: this.GoodsGroupIds,
      GoodsIds: this.GoodsIds,
      SellerIds: this.SellerIds,
      WarehouseIds: this.WarehouseIds,
      SellKindIds: this.SellKindIds,
      OnlySupplier: false,
      IsGoods: false,
      SlaveNo: undefined,
      StartNumber: undefined,
      EndNumber: undefined,
      IsService: false,
      TraceElement: undefined,
      ReceiptDate: undefined,
      ShowBeginingOfTheCoursResidue: false,
      ShowRunningTotal: false,
    });
    this.service.filter$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
      if (x) {
        let ShowBeforeRemain: boolean = x.items.some((r) => r.key === "ShowBeforeRemain");
        let AmountRemain: boolean = x.items.some((r) => r.key === "ShowRunningTotal");
        if (AmountRemain) {
          this.GetVoucherDetailColumns.find((x) => x.name === "AmountRemain").listVisible = true;
        }
        this.populateGridColumns();
      }
    });
    this.populateGridColumns();
    this.setColumns();
  }
  setColumns() {
    this.httpCommonService
      .get("SellCustomerReview/GetSellCustomerReviewInfo")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          if (data) {
            this.GetVoucherDetailColumns = data as form_control[];
            this.GetVoucherDetailColumns = this.GetVoucherDetailColumns.sort((a, b) => a.order - b.order);
            this.setColumnVisiblty();
          }
        },
        (error) => console.log(error)
      );
  }
  setColumnVisiblty() {}
  populateGridColumns(): any {
    var col: form_control[] = [];
    col = [
      {
        name: "Id",
        modelName: "Id",
        listVisible: false,
        label: "سریال",
        order: 0,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Amount",
        modelName: "Amount",
        listVisible: true,
        label: "تعداد",
        order: 11,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "MainAmount",
        modelName: "MainAmount",
        listVisible: false,
        label: "تعداد اصلی",
        order: 11,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "OutputAmount",
        modelName: "OutputAmount",
        listVisible: true,
        label: "مقدار فروش",
        order: 11,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "MainOutputAmount",
        modelName: "MainOutputAmount",
        listVisible: false,
        label: "مقدار اصلی فروش",
        order: 11,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "OutputPrice",
        modelName: "OutputPrice",
        listVisible: true,
        label: "مبلغ فروش",
        order: 13,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "InputAmount",
        modelName: "InputAmount",
        listVisible: true,
        label: "مقدار برگشتي",
        order: 14,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "MainInputAmount",
        modelName: "MainInputAmount",
        listVisible: false,
        label: "مقدار اصلی برگشتي",
        order: 14,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "InputPrice",
        modelName: "InputPrice",
        listVisible: true,
        label: "مبلغ برگشتی",
        order: 14,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "DiscountAmount",
        modelName: "DiscountAmount",
        listVisible: true,
        label: "تخفیف",
        order: 17,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Surplusage",
        modelName: "Surplusage",
        listVisible: true,
        label: "اضافات",
        order: 18,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Deduction",
        modelName: "Deduction",
        listVisible: true,
        label: "کسور",
        order: 19,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
    ];
    this.GetSellVoucherKindColumns = [];
    Object.assign(this.GetSellVoucherKindColumns, col);
    this.GetSellVoucherKindColumns.push({
      name: "VoucherKindCode",
      modelName: "VoucherKind.Code",
      listVisible: true,
      label: "کد",
      order: 1,
      textType: "number",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetSellVoucherKindColumns.push({
      name: "VoucherKindTitle",
      modelName: "VoucherKind.Title",
      listVisible: true,
      label: "عنوان",
      order: 2,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetSellVoucherKindColumns = this.GetSellVoucherKindColumns.sort((a, b) => a.order - b.order);

    this.GetSellKindColumns = [];
    Object.assign(this.GetSellKindColumns, col);
    this.GetSellKindColumns.push({
      name: "SellKindCode",
      modelName: "SellKind.Code",
      listVisible: true,
      label: "کد",
      order: 1,
      textType: "number",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetSellKindColumns.push({
      name: "SellKindTitle",
      modelName: "SellKind.Title",
      listVisible: true,
      label: "عنوان",
      order: 2,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetSellKindColumns = this.GetSellKindColumns.sort((a, b) => a.order - b.order);

    this.GetCustomerColumns = [];
    Object.assign(this.GetCustomerColumns, col);
    this.GetCustomerColumns.push({
      name: "DetailLedgerCode",
      modelName: "DetailLedgerCode",
      listVisible: true,
      label: "کد",
      order: 1,
      textType: "number",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetCustomerColumns.push({
      name: "DetailLedgerTitle",
      modelName: "DetailLedgerTitle",
      listVisible: true,
      label: "عنوان",
      order: 2,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetCustomerColumns = this.GetCustomerColumns.sort((a, b) => a.order - b.order);

    this.GetWarehouseColumns = [];
    Object.assign(this.GetWarehouseColumns, col);
    this.GetWarehouseColumns.push({
      name: "WarehouseCode",
      modelName: "Warehouse.Code",
      listVisible: true,
      label: "کد",
      order: 1,
      textType: "number",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetWarehouseColumns.push({
      name: "WarehouseTitle",
      modelName: "Warehouse.Title",
      listVisible: true,
      label: "انبار",
      order: 2,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetWarehouseColumns = this.GetWarehouseColumns.sort((a, b) => a.order - b.order);

    this.GetGoodsGroupColumns = [];
    Object.assign(this.GetGoodsGroupColumns, col);
    this.GetGoodsGroupColumns.push({
      name: "GoodsGroupCode",
      modelName: "GoodsGroup.TreeCode",
      listVisible: true,
      label: "کد",
      order: 1,
      textType: "number",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetGoodsGroupColumns.push({
      name: "GoodsGroupTitle",
      modelName: "GoodsGroup.TreePath",
      listVisible: true,
      label: "عنوان",
      order: 2,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetGoodsGroupColumns = this.GetGoodsGroupColumns.sort((a, b) => a.order - b.order);

    this.GetSellerColumns = [];
    Object.assign(this.GetSellerColumns, col);
    this.GetSellerColumns.push({
      name: "SellerCode",
      modelName: "SellerCode",
      listVisible: true,
      label: "کد",
      order: 1,
      textType: "number",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetSellerColumns.push({
      name: "SellerTitle",
      modelName: "SellerTitle",
      listVisible: true,
      label: "عنوان",
      order: 2,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetSellerColumns = this.GetSellerColumns.sort((a, b) => a.order - b.order);

    this.GetGoodsColumns = [];
    Object.assign(this.GetGoodsColumns, col);
    this.GetGoodsColumns.push({
      name: "GoodsCode",
      modelName: "Goods.Code",
      listVisible: true,
      label: "کد",
      order: 1,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetGoodsColumns.push({
      name: "GoodsTitle",
      modelName: "Goods.Title",
      listVisible: true,
      label: "عنوان",
      order: 2,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetGoodsColumns.push({
      name: "GoodsGroupCode",
      modelName: "GoodsGroup.TreeCode",
      listVisible: true,
      label: "کد گروه",
      order: 3,
      textType: "number",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetGoodsColumns.push({
      name: "GoodsGroupTitle",
      modelName: "GoodsGroup.TreePath",
      listVisible: true,
      label: "عنوان گروه",
      order: 4,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetGoodsColumns.push({
      name: "GoodsUnitTitle",
      modelName: "GoodsUnitTitle",
      listVisible: true,
      label: "واحد سنجش",
      order: 5,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetGoodsColumns.push({
      name: "GoodsMainUnitTitle",
      modelName: "GoodsMainUnitTitle",
      listVisible: true,
      label: "واحد سنجش اصلی",
      order: 5,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetGoodsColumns = this.GetGoodsColumns.sort((a, b) => a.order - b.order);

    this.GetVoucherHeaderColumns = [];
    Object.assign(this.GetVoucherHeaderColumns, col);
    this.GetVoucherHeaderColumns.push({
      name: "VoucherKindTitle",
      modelName: "VoucherKindT.itle",
      listVisible: true,
      label: "نوع سند",
      order: 1,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetVoucherHeaderColumns.push({
      name: "VoucherNo",
      modelName: "VoucherNo",
      listVisible: true,
      label: "شماره سند",
      order: 2,
      textType: "number",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetVoucherHeaderColumns.push({
      name: "ShamsiVoucherDate",
      modelName: "ShamsiVoucherDate",
      listVisible: true,
      label: "تاریخ سند",
      order: 3,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetVoucherHeaderColumns.push({
      name: "ShamsiReceiptDate",
      modelName: "ShamsiReceiptDate",
      listVisible: true,
      label: "تاریخ وصول",
      order: 4,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetVoucherHeaderColumns.push({
      name: "Invoicecredit",
      modelName: "Invoicecredit",
      listVisible: true,
      label: "اعتبار به روز",
      order: 5,
      textType: "number",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetVoucherHeaderColumns.push({
      name: "SlaveNo",
      modelName: "SlaveNo",
      listVisible: true,
      label: "َشماره پیگیری",
      order: 6,
      textType: "number",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetVoucherHeaderColumns.push({
      name: "DetailLedgerCode",
      modelName: "DetailLedger.Code",
      listVisible: true,
      label: "کد طرف مقابل",
      order: 7,
      textType: "number",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetVoucherHeaderColumns.push({
      name: "DetailLedgerTitle",
      modelName: "DetailLedger.Title",
      listVisible: true,
      label: "طرف مقابل",
      order: 8,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetVoucherHeaderColumns.push({
      name: "WarehouseTitle",
      modelName: "WarehouseTitle",
      listVisible: true,
      label: "انبار",
      order: 9,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetVoucherHeaderColumns = this.GetVoucherHeaderColumns.sort((a, b) => a.order - b.order);

    this.GetGoodsCardAmountColumns = [];
    this.GetGoodsCardAmountColumns.push({
      name: "BranchTitle",
      modelName: "BranchTitle",
      listVisible: true,
      label: "َشعبه",
      order: 1,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetGoodsCardAmountColumns.push({
      name: "WarehouseTitle",
      modelName: "Warehouse.Title",
      listVisible: true,
      label: "َانبار",
      order: 2,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetGoodsCardAmountColumns.push({
      name: "GoodsCode",
      modelName: "Goods.Code",
      listVisible: true,
      label: "َکدکالا",
      order: 3,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetGoodsCardAmountColumns.push({
      name: "GoodsTitle",
      modelName: "Goods.Title",
      listVisible: true,
      label: "َکالا",
      order: 4,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetGoodsCardAmountColumns.push({
      name: "GoodsMainUnitTitle",
      modelName: "GoodsMainUnit.Title",
      listVisible: true,
      label: "واحد سنجش",
      order: 5,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetGoodsCardAmountColumns.push({
      name: "ShamsiVoucherDate",
      modelName: "ShamsiVoucherDate",
      listVisible: true,
      label: "تاریخ سند",
      order: 5,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetGoodsCardAmountColumns.push({
      name: "Comment",
      modelName: "Comment",
      listVisible: true,
      label: "شرح",
      order: 6,
      textType: "text",
      withComma: true,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetGoodsCardAmountColumns.push({
      name: "MainInputAmount",
      modelName: "MainInputAmount",
      listVisible: true,
      label: "مقدار وارده",
      order: 6,
      textType: "number",
      withComma: true,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetGoodsCardAmountColumns.push({
      name: "MainOutputAmount",
      modelName: "MainOutputAmount",
      listVisible: true,
      label: "مقدارصادره",
      order: 7,
      textType: "number",
      withComma: true,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetGoodsCardAmountColumns = this.GetGoodsCardAmountColumns.sort((a, b) => a.order - b.order);

    this.GetGoodsCardPriceColumns = [];
    Object.assign(this.GetGoodsCardPriceColumns, this.GetGoodsCardAmountColumns);
    this.GetGoodsCardPriceColumns.push({
      name: "InputPrice",
      modelName: "InputPrice",
      listVisible: true,
      label: "وارده ریالی",
      order: 9,
      textType: "number",
      withComma: true,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetGoodsCardPriceColumns.push({
      name: "OutputPrice",
      modelName: "OutputPrice",
      listVisible: true,
      label: "صادره ریالی",
      order: 9,
      textType: "number",
      withComma: true,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetGoodsCardPriceColumns = this.GetGoodsCardPriceColumns.sort((a, b) => a.order - b.order);
  }
  isActveTab(title: string) {
    return this.activeTabTitle === title;
  }
  selectTab($event) {
    this.activeTabTitle = $event.tabTitle;
  }
  onActionClick(action: EntityListAction, onRowSelected: any, onRowsSelected: any[], isAllSelected: boolean, gridFilter: GridFilter[]) {
    ///نمایش سند حسابداری
    if (action.name === "AccVoucherHeader") {
      var datatrasfer: Datatransfer = <Datatransfer>{};
      onRowSelected.Id = onRowSelected.AccVoucherHeaderId;
      datatrasfer.apiName = action.apiName;
      datatrasfer.areaName = action.areaName;
      datatrasfer.currentrow = onRowSelected;
      action.Form_Component = AccVoucherFormComponent;
      datatrasfer.apiName = "AccVoucherHeader";
      datatrasfer.areaName = "Accounting";
      datatrasfer.label = "سند حسابداری";
      if (onRowSelected.AccVoucherHeaderId) this.showVoucher(datatrasfer, action);
    }

    ///سند مبنا
    if (action.name === "BaseVoucher") {
      var datatrasfer: Datatransfer = <Datatransfer>{};
      onRowSelected.Id = onRowSelected.VoucherHeaderId;
      datatrasfer.apiName = action.apiName;
      datatrasfer.areaName = action.areaName;
      datatrasfer.currentrow = onRowSelected;
      action.Form_Component = SellVoucherFormComponent;
      datatrasfer.apiName = action.apiName;
      datatrasfer.areaName = action.areaName;
      datatrasfer.label = "سند فروش و مشتری";
      if (onRowSelected.VoucherHeaderId) this.showVoucher(datatrasfer, action);
    }
  }
  showVoucher(datatrasfer: Datatransfer, action: any) {
    const menu = <ITab>{
      title: datatrasfer.label,
      isCloseable: true,
      icon: action.iconName,
      active: true,
      responsive: true,
      componentType: action.Form_Component,
      data: [
        { provide: EntityBase, useValue: datatrasfer.currentrow },
        { provide: Datatransfer, useValue: datatrasfer },
        { provide: VoucherKindInfo, useValue: <VoucherKindInfo>{ VoucherKindId: 0 } },
      ],
    };
    this.tabsservice.open(menu);
  }
  setactions() {
    this.actions = [
      {
        name: "AccVoucherHeader",
        disabled: false,
        isModal: false,
        displayName: "سند حسابداری",
        iconName: "icon-table_view-f",
        Form_Component: AccVoucherFormComponent,
        apiName: "AccVoucherHeader",
        areaName: "Accounting",
        permission: Permission.viewPermission,
      },
      {
        name: "BaseVoucher",
        disabled: false,
        isModal: false,
        displayName: "سند مبنا",
        iconName: "icon-folder-open-outline",
        areaName: "SellCustomer",
        Form_Component: SellVoucherFormComponent,
        apiName: "SellVoucherHeader",
        permission: Permission.viewPermission,
      },
      {
        name: "GetGoodsHistory",
        disabled: false,
        displayName: "تاریخچه",
        iconName: "icon-history-o",
        areaName: "SellCustomer",
        Form_Component: SellVoucherFormComponent,
        apiName: "SellCustomerReview/GetGoodsHistory",
        permission: Permission.samePermission,
      },
    ];
  }
  setSelectedFilter(filter: string) {
    if (this.selected === filter) this.selected = "";
    else this.selected = filter;
  }
}
